<template>
  <div>
    <el-button @click="batchAuditPass" type="primary" v-if="activeTab == 'all' || activeTab == '0'">一键审核通过</el-button>
    <el-table :data="auditList" ref="multipleTable" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" v-if="(activeTab == 'all' || activeTab == '0')"   :selectable='checkboxT'></el-table-column>



      <el-table-column min-width="60" label="时间">
        <template slot-scope="scope">{{ scope.row.createdTime | moment }}</template>
      </el-table-column>
      <el-table-column label="账号" min-width="150px">
        <template slot-scope="scope">
          <div class="copystyle">
            <a class="account-link" @click="getUserDetail(scope.row.userId)">{{ scope.row.userId }}</a>
            <img width="18px" @click="getcopy(scope.row.userId)" src="../../../../../assets/images/copy.png"/>
          </div>
        </template>
      </el-table-column>
        <el-table-column prop="multiChainInfo" label="所属链"></el-table-column>
      <el-table-column prop="txCoin" label="币种"></el-table-column>
      <el-table-column prop="txAmount" label="充值数量">
        <template slot-scope="scope">
          <span>{{ scope.row.txAmount | toThousands }}</span>
        </template>
      </el-table-column>
      <el-table-column label="充值地址" min-width="150">
        <template slot-scope="scope">
          <a :href="scope.row.txNetworkLink" target="_blank" class="network-link">{{ scope.row.txToAddress }}</a>
        </template>
      </el-table-column>
       <el-table-column label="Memo" min-width="120">
        <template slot-scope="scope">
        <span>{{scope.row.txToMemo}}</span>
        </template>
      </el-table-column>
      <el-table-column label="hash">
        <template slot-scope="scope">
          <a :href="scope.row.txHash" target="_blank" class="network-link">{{ scope.row.txHash }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="txStatus" label="充值状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.__status && scope.row.txStatus === 0" :type="scope.row.__status.color">{{ scope.row.__status.text }}</el-tag>
          <span v-if="scope.row.txStatus !== 0" class="text-disabled">{{ scope.row.__status.text }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="txStatus" label="人工确认">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.__depositStatus" :type="scope.row.__depositStatus.color">{{ scope.row.txDepositDesc }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" show-overflow-tooltip label="备注"></el-table-column>
      <el-table-column prop="extraInfo" show-overflow-tooltip label="其他信息"></el-table-column>
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.txStatus !== 3 && scope.row.txStatus !== 10">
            <template v-if="scope.row.txDepositStatus === 1">
              <el-tooltip content="确认">
                <el-button
                  type="success"
                  size="small"
                  circle
                  icon="el-icon-success"
                  @click="ensureAudit(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="异常">
                <el-button
                  type="danger"
                  @click="setAuditError(scope.row)"
                  icon="el-icon-warning"
                  size="small"
                  circle
                ></el-button>
              </el-tooltip>
            </template>
            <template v-else>
              <el-tooltip content="重置">
                <el-button @click="resetAudit(scope.row)" icon="el-icon-refresh" size="small" circle></el-button>
              </el-tooltip>
            </template>
          </div>
          <div v-if="scope.row.txStatus === 3 || scope.row.txStatus === 10">
            <el-select :value="scope.row.txDepositStatus" @change="alterInnerDepositStatus(scope.row.id, $event)">
              <el-option v-for="item in innerStatus" :label="item.desc" :key="item.code" :value="item.code"></el-option>
            </el-select>
          </div>
          <el-button style="margin:10px" type="success" @click="showLog(scope.row)">查看日志</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager-wrap" style="text-align:right;margin:10px 0px;">
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="audistCount"
        @pageChanged="handleCurrentChange"
      ></pagination>
    </div>
     <!-- <div class="pager-wrap" style="text-align:right;margin:10px 0px;">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-size="pagination.size"
          :total="audistCount"
          prev-text="上一页"
          next-text="下一页"
        >
        </el-pagination>
         </div>  -->
    <div class="send-trans-dialog">
      <el-dialog :visible.sync="ifShowSendDialog" @close="closeSendDialog" width="800px">
        <el-form :model="sendTransForm" ref="sendTransForm" label-width="100px">
          <el-form-item prop="transId" label="网络ID" :rules="[{ required: true, message: '请输入网路ID' }]">
            <el-input v-model="sendTransForm.transId"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="sendTransNow()">确定提交</el-button>
            <el-button @click="closeSendDialog()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>

    <balance :show="showUserDialog" @close="showUserDialog = false"></balance>

    <ShowLogDialog ref="showLogDialog" :show-desc="true"></ShowLogDialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Pagination from "components/pagination";
import balance from "../../../balance";
import api from "../../api";
import ShowLogDialog from "../ShowLogDialog.vue";
export default {
  name: "AuditList",
  data() {
    return {
      showUserDialog: false,
      ifShowSendDialog: false,
      sendOrderId: "",
      sendTransForm: {
        id: ""
      },
      retryableStatus: ["FAIL_CANNOT_RETRY", "EXECUTING_WITHDRAW", "HOT_NOT_ENOUGH_MONEY", "DUPLICATE_TO_ADDRESS"],
      innerStatus: [
        { code: 0, desc: "已确认" },
        { code: 1, desc: "未确认" }
      ],
      multipleSelection: [],
      showLogDialog: false,
      showLogData: {},
    };
  },
  props: {
    parameter: Object,
    required: true
  },
  computed: {
    ...mapState("depositAudit", ["auditList", "allCoins", "audistCount", "pagination", "activeTab"]),
    ...mapState(["userInfo"]),
  },
  filters: {
    toThousands(num) {
      let result = "",
        counter = 0;
      num = (num || 0).toString();
      let n1 = num.split(".");
      if (n1.length == 0) {
        return result;
      }
      for (var i = n1[0].length - 1; i >= 0; i--) {
        counter++;
        result = n1[0].charAt(i) + result;
        if (!(counter % 3) && i != 0) {
          result = "," + result;
        }
      }

      if (n1.length == 2) {
        return result + "." + n1[1];
      }
      return result;
    }
  },
  methods: {
    ...mapActions("depositAudit", [
      "ensure",
      "reset",
      "resetUserRecords",
      "abnormal",
      "cancel",
      "updateFreeze",
      "sendWithdrawalTrans",
      "remark",
      "manualConfirm",
      "returnToNotApproved"
    ]),
    ...mapActions("withdrawalAudit", ["getUserWallet",'getRebateAmount']),
      checkboxT(row, rowIndex){
        if(row.txStatus === 0 && row.txDepositStatus === 0){
          return false;//禁用
        }else{
          return true;//不禁用
        }
      },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchAuditPass() {
      if (this.multipleSelection.length <= 0) {
        this.$message.info("请勾选需要审核的数据");
        return;
      }
      this.$confirm("确认进行批量审核吗", "提示", {
        type: "warning"
      })
        .then(() => {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            this.ensure(this.multipleSelection[i].id);
          }
          this.refreshList();
        })
        .catch(() => {});
    },
    showPrompt(content, audit, callback) {
      return this.$prompt(content, "提示", {
        inputPlaceholder: "备注信息",
        inputValue: audit.remark
      }).then(({ value }) => {
        return callback()
          .then(() => {
            return value !== audit.remark ? this.remark({ id: audit.id, remark: value }) : Promise.resolve(); //如果值未修改则不请求
          })
          .then(() => {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.refreshList();
          });
      });
    },
    ensureAudit(audit) {
      this.showPrompt("确认通过审核吗？", audit, () => this.ensure(audit.id));
    },
    resetAudit(audit) {
      this.showPrompt("重置会将人工审核状态还原为[未确认]，确认要重置吗？", audit, () => this.reset(audit.id));
    },
    setAuditError(audit) {
      this.showPrompt("确认将该记录置为异常？", audit, () => this.abnormal(audit.id));
    },
    getUserDetail(uid) {
      this.getUserWallet({ userId: uid });
      this.getRebateAmount({ userId: uid })
      this.showUserDialog = true;
    },
    refreshList() {
      // this.handleCurrentChange({
      //   page: 1
      // });
      this.$emit("refresh", this.pagination);
    },
    
    handleCurrentChange(pagination) {
      this.$store.commit('depositAudit/setPagination',{...pagination})
      this.$emit("refresh", pagination);
    },
    showSendDialog(id) {
      this.sendOrderId = id;
      this.ifShowSendDialog = true;
    },
    sendTransNow() {
      this.$refs["sendTransForm"].validate(valid => {
        if (valid) {
          this.sendWithdrawalTrans({
            id: this.sendOrderId,
            transId: this.sendTransForm.transId
          }).then(() => {
            this.closeSendDialog();
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.refreshList();
          });
        }
      });
    },
    closeSendDialog() {
      this.$refs["sendTransForm"] && this.$refs["sendTransForm"].resetFields();
      this.ifShowSendDialog = false;
    },
    handleManualConfirm(txId) {
      this.$confirm("确认手动转账已成功吗？", "提示", {
        type: "warning"
      }).then(() => {
        this.manualConfirm(txId).then(() => {
          this.$message.success("操作成功！");
          this.refreshList();
        });
      });
    },
    handleReturnToNotApproved(txId) {
      this.$confirm("确认退回未审核状态吗？", "提示", {
        type: "warning"
      }).then(() => {
        this.returnToNotApproved(txId).then(() => {
          this.$message.success("操作成功！");
          this.refreshList();
        });
      });
    },
    alterInnerDepositStatus(id, innerStatus) {
      let data = { id: id, innerStatus: innerStatus };
      api.changeInnerDepositStatus(data).then(() => {
        this.refreshList();
      });
    },

    //查看日志
    showLog(row) {
      let showLogDialog = this.$refs["showLogDialog"];
      showLogDialog.setVisible(true);
      showLogDialog.setInfo(row);
    },
    getcopy(userid){
      let oInput = document.createElement('input'); 
      oInput.value = userid;    //赋值
      document.body.appendChild(oInput);
      oInput.select(); 
      document.execCommand("Copy"); 
      oInput.className = 'oInput';
      oInput.style.display = 'none';
      this.$message.success('复制成功');
    }
  },
  components: {
    Pagination,
    balance,
    ShowLogDialog
  }
};
</script>

<style lang="less" scoped>
@import url("~styles/variables.less");

.account-link,
.network-link {
  color: @color-primary;
  &:hover {
    text-decoration: underline;
  }
}

.el-button--success {
  margin-top: 12px;
}
.copystyle{
  display: flex;
  align-items: center;
  img{
    cursor:pointer;
  }
}
</style>
